import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { Title } from '@angular/platform-browser'
import { MaintenanceService } from '../../services/maintenance.service'
import { interval, Subject, takeUntil } from 'rxjs'
import { getTitle } from '../../util/accessibility' // 参考UIと同様のユーティリティ関数

@Component({
  selector: 'app-maintenance',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './maintenance.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './maintenance.component.scss',
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>()

  constructor(
    private maintenanceService: MaintenanceService,
    private titleService: Title,
  ) {
    this.titleService.setTitle(getTitle('システムメンテナンス中'))
  }

  ngOnInit() {
    // 30秒ごとに自動更新チェック
    interval(30000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(async () => {
        try {
          await this.maintenanceService.refreshConfig()
        } catch (error) {
          console.error('Auto refresh failed:', error)
        }
      })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  async forceRefresh() {
    try {
      await this.maintenanceService.refreshConfig()
      // メンテナンスが終了していなければページ全体をリロード
      setTimeout(() => {
        if (this.maintenanceService.getCurrentMaintenanceMode()) {
          window.location.reload()
        }
      }, 1000)
    } catch (error) {
      console.error('Manual refresh failed:', error)
      // エラーの場合はページを強制リロード
      window.location.reload()
    }
  }
}
